// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Jackpot statistics drawer. */
.FoAxJKgkOhyTlHyJOvOJ {
  --jp-stats-gold: #FFC61B;
  --jp-stats-row-divider: #2e2e2e;
  --jp-stats-radius: 12px;
  --jp-stats-border-width: 2px;
  --jp-stats-border-color: rgba(255, 255, 255, 0.15);
  --jp-stats-head-height: 30px;
  --jp-stats-gradient: linear-gradient(180deg, #323334 0, #323334 var(--jp-stats-radius), #101012 var(--jp-stats-head-height), #1c1c1e 83.29%);
  --jp-stats-header-gradient: linear-gradient(180deg, #323334 0%, #101012 100%);
  --jp-stats-shadow-offset: 20px;
  --jp-stats-shadow-blur: 40px;
  --jp-stats-shadow-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  background: rgba(0, 0, 0, 0.65);
  font-family: var(--font-family-primary);
  overscroll-behavior: contain;
  align-items: stretch;
  justify-content: flex-end;
}
.Q0Qd6fpVaABhND1xnxOg {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden;
  background: var(--jp-stats-gradient);
  background-origin: border-box;
  color: var(--white-color, #fff);
  border-style: solid;
  border-color: var(--jp-stats-border-color);
  /* The notch inset is ADDED to the width, not carved out of it: with border-box sizing a bare
     375px would lose the safe-area padding from its content box and clip the GAME column. */
  width: min(calc(375px + var(--safe-right, 0px)), 100%);
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  padding-right: var(--safe-right, 0px);
  border-width: var(--jp-stats-border-width) 0 var(--jp-stats-border-width) var(--jp-stats-border-width);
  border-radius: var(--jp-stats-radius) 0 0 var(--jp-stats-radius);
  box-shadow: calc(-1 * var(--jp-stats-shadow-offset)) 0 var(--jp-stats-shadow-blur) 0 var(--jp-stats-shadow-color);
  --jp-stats-enter-from: translateX(24px);
  animation: k2EIwtF9CVBnhlj9zKTB 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}
/*
 * DESKTOP - the whole drawer is drawn 1.25x.
 *
 * Done with one \`zoom\` rather than by multiplying the ~100 px literals in this file: zoom scales
 * LAYOUT, not just paint, so every token (widths, gaps, radii, borders, font sizes, the row grid)
 * grows by exactly the same factor, text is rasterised at the larger size instead of being
 * stretched, and hit areas follow. The numbers below stay the Figma mobile numbers, which is what
 * makes them checkable against the design.
 */
@media (min-width: 1024px) {
  .FoAxJKgkOhyTlHyJOvOJ[data-device='desktop'] .Q0Qd6fpVaABhND1xnxOg {
    --jp-stats-zoom: 1.25;
    zoom: var(--jp-stats-zoom);
    height: calc(100vh / var(--jp-stats-zoom));
    height: calc(100dvh / var(--jp-stats-zoom));
    max-height: calc(100vh / var(--jp-stats-zoom));
    max-height: calc(100dvh / var(--jp-stats-zoom));
  }
}
/*
 * PHONE PORTRAIT — and only phone portrait — turns the side drawer into a bottom sheet. Every
 * other form factor keeps the right-side drawer above, iPads and tablets included.
 *
 */
@media (orientation: portrait) and (max-width: 600px) {
  .FoAxJKgkOhyTlHyJOvOJ {
    align-items: flex-end;
    justify-content: center;
  }
  /* Mirrored to the bottom edge: radius on the top two corners, no border on the bottom,
     shadow cast upward over the lobby. A FIXED height, not content-driven: switching to a level
     with fewer wins must not shrink the sheet and shift it down the screen. */
  .Q0Qd6fpVaABhND1xnxOg {
    width: 100%;
    height: calc(100vh * 0.86);
    height: calc(100dvh * 0.86);
    max-height: calc(100vh * 0.86);
    max-height: calc(100dvh * 0.86);
    padding-right: 0;
    padding-bottom: var(--safe-bottom, 0px);
    border-width: var(--jp-stats-border-width) var(--jp-stats-border-width) 0 var(--jp-stats-border-width);
    border-radius: var(--jp-stats-radius) var(--jp-stats-radius) 0 0;
    box-shadow: 0 calc(-1 * var(--jp-stats-shadow-offset)) var(--jp-stats-shadow-blur) 0 var(--jp-stats-shadow-color);
    --jp-stats-enter-from: translateY(24px);
  }
}
@keyframes k2EIwtF9CVBnhlj9zKTB {
  0% {
    opacity: 0;
    transform: var(--jp-stats-enter-from);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Header panel */
.gS07Do2zmX4KudQvS3DR {
  display: flex;
  flex: 0 0 auto;
  /* The drawer fill’s light top, now attached to the panel it was drawn for so it scrolls away
     with it instead of staying behind the list. */
  background: var(--jp-stats-header-gradient);
  gap: 12px;
  padding: 8px 8px;
}
/*
 * PHONE LANDSCAPE — and only phone landscape — drops the header
 */
@media (orientation: landscape) and (max-height: 600px) and (pointer: coarse) {
  .gS07Do2zmX4KudQvS3DR {
    display: none;
  }
}
/* Caption only — no win under the current filter. Centred so the band still reads as a title. */
.qONfW82yXw1jyr7UMeXv {
  justify-content: center;
  padding: 10px 8px;
}
.Dax7maqz0rgckGT6LGJQ {
  position: relative;
  display: block;
  flex: 0 0 auto;
  width: 89px;
  height: 102px;
  padding: 0;
  border: 0;
  overflow: hidden;
  background: #222;
  cursor: pointer;
  border-radius: 6.85px;
}
.Dax7maqz0rgckGT6LGJQ:disabled {
  cursor: wait;
}
.ZoSN__XbMQz4vysP6_A8 {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  display: block;
  border-radius: 6.85px;
}
/* Three stacked lines to the right of the thumbnail, left-aligned: caption / level / amount. */
.h2jGJfsoJzyNMc46SD31 {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  margin-top: 1px;
}
.d1dam9Pcd5Upc1gvrLFx {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--jp-stats-gold);
  text-transform: uppercase;
  font-family: var(--font-family-secondary);
  line-height: 100%;
}
/* The amount is white; only the level wordmark image carries colour. Stretched to the column so
   AutoTextfit scales the number to it (its maxFontSize sets the size); the currency is in em
   so it scales along. Same for .payoutAmount below. */
.NE6TEvyrzzzDhuh4Ia7Q {
  align-self: stretch;
  min-width: 0;
  font-weight: 800;
  color: var(--white-color, #fff);
  font-family: var(--font-family-secondary);
  line-height: 1;
  letter-spacing: 0%;
}
.h2jGJfsoJzyNMc46SD31:not([data-premium-link='true']) .d1dam9Pcd5Upc1gvrLFx {
  position: relative;
  left: 1px;
}
.g23TnvbRQ4colqleaP0w {
  margin-left: calc(4em / 29);
  font-size: calc(14em / 29);
  font-weight: 800;
  color: var(--white-color, #fff);
  line-height: 100%;
  letter-spacing: 0%;
}
/* Level label (shared by header, rows and footer chips) */
.ofEWnpTpzDRwbq8XUyEo {
  display: block;
  width: auto;
  max-width: 100%;
  height: var(--jp-stats-label-height, 14px);
  object-fit: contain;
}
.LgA6RFMrGS6jHjqULHf9 {
  font-size: calc(var(--jp-stats-label-height, 14px) * 0.85);
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1;
  color: var(--jp-level-text, var(--ghost-white-color, #f9f9f9));
  white-space: nowrap;
}
/* Premium Link's Super / Middle wordmarks are green / blue, so they share major's and minor's
   colours; its Mini is the same magenta as everyone else's. */
.LgA6RFMrGS6jHjqULHf9[data-level='grand'] {
  --jp-level-text: #ff5b6e;
}
.LgA6RFMrGS6jHjqULHf9[data-level='major'],
.LgA6RFMrGS6jHjqULHf9[data-level='super'] {
  --jp-level-text: #3ddc61;
}
.LgA6RFMrGS6jHjqULHf9[data-level='minor'],
.LgA6RFMrGS6jHjqULHf9[data-level='middle'] {
  --jp-level-text: #5b9bff;
}
.LgA6RFMrGS6jHjqULHf9[data-level='mini'] {
  --jp-level-text: #cf7bee;
}
.D_SOBmY1InznkrXKANTo {
  display: block;
  flex: 0 0 auto;
  width: auto;
  height: var(--jp-stats-vip-height, 13.17px);
  margin-right: 4px;
  object-fit: contain;
}
.YsTRDYu6JUjqkD9pLxYY {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  max-width: 100%;
  --jp-stats-label-height: 24px;
  --jp-stats-vip-height: 24px;
}
/* Content panel */
.GYmPaGqowkvFuatXOxWN {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  flex-direction: column;
}
.s9KFsU6iWhBmUAGF8u5S,
.oFocP4cgUkcqw8g1fHhp {
  /* Named so the row separator can line up with both ends of the grid — see \`.row::after\`. */
  --jp-stats-grid-gap: 8px;
  --jp-stats-grid-padding: 8px;
  --jp-stats-game-col: 44px;
  --jp-stats-rank-col: 34px;
  /* Width of the rank pill itself, which is centred in the track above — see \`.rank\`. */
  --jp-stats-rank-width: 24px;
  display: grid;
  grid-template-columns: var(--jp-stats-rank-col) minmax(52px, 0.8fr) minmax(96px, 1.4fr) minmax(64px, 1fr) var(--jp-stats-game-col);
  align-items: center;
  gap: var(--jp-stats-grid-gap);
  padding: 0 var(--jp-stats-grid-padding);
}
.s9KFsU6iWhBmUAGF8u5S {
  flex: 0 0 auto;
  height: var(--jp-stats-head-height);
  background: #252528;
  position: sticky;
  top: 0;
  z-index: 1;
  transition: box-shadow 0.15s ease-out;
}
.s9KFsU6iWhBmUAGF8u5S[data-elevated='true'] {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.6), 0 14px 32px 0 rgba(0, 0, 0, 0.75);
}
.DakiyXCSai9hGjKibeaq {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: var(--ash-grey, #b0b0b0);
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--font-family-secondary);
}
.k4QRwIt6ArDhL48Dy6YP {
  display: block;
  text-align: center;
  position: relative;
  left: -4px;
}
/*
 * One scroller for the header panel, the sticky column headings and the rows. The scrollbar is
 * hidden rather than styled: the Figma frames show none, and a classic scrollbar would eat ~10px
 * of layout width mid-list. Scrolling itself is untouched — wheel, trackpad, touch and keyboard
 * all still work; on touch platforms scrollbars already overlay at zero width.
 */
.zLVTnBcxFojqnkpRgfxL {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: none;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.zLVTnBcxFojqnkpRgfxL::-webkit-scrollbar {
  display: none;
}
/* While there are no rows the list is a flex column, so the placeholder below the sticky
   headings can take all the remaining height and centre itself in it. */
.zLVTnBcxFojqnkpRgfxL[data-empty='true'] {
  display: flex;
  flex-direction: column;
}
.c64mltkptQUvUylrdtgj {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  text-align: center;
}
.xzvNql9GPRSzgL8BnBgj {
  display: block;
  width: 56px;
  height: 56px;
  object-fit: contain;
}
.B0yeNC1kM3iZAEEQKEAb {
  margin: 0;
  max-width: 280px;
  font-family: var(--font-family-secondary);
  font-size: 16px;
  font-weight: 800;
  line-height: 1.3;
  color: var(--white-color, #fff);
}
/* Focused programmatically on open (keyboard scroll target) — never a visible ring. */
.zLVTnBcxFojqnkpRgfxL:focus {
  outline: none;
}
.oFocP4cgUkcqw8g1fHhp {
  position: relative;
  height: 56px;
}
/*
 * Separator drawn as a pseudo-element rather than \`border-bottom\`, because it must stop where the
 * GAME column begins instead of running the full width under the thumbnail. The right offset is
 * derived from the grid itself — game track + the gap before it + the row's right padding — so it
 * follows automatically if any of those change.
 */
.oFocP4cgUkcqw8g1fHhp::after {
  content: '';
  position: absolute;
  /*
   * Starts at the left edge of the rank PILL, not of its grid track and not of the drawer:
   * offsets on an absolutely positioned child resolve against the PADDING box, so the row's own
   * padding is added back, plus the slack the pill is centred by inside its wider track. Derived
   * rather than hard-coded, so the narrow-phone track override below stays aligned.
   */
  left: calc(var(--jp-stats-grid-padding) + (var(--jp-stats-rank-col) - var(--jp-stats-rank-width)) / 2 - 4px);
  /* Ends exactly where the TIME & DATE track ends — i.e. one gap before the GAME track. */
  right: calc(var(--jp-stats-game-col) + var(--jp-stats-grid-gap) + var(--jp-stats-grid-padding));
  bottom: 0;
  height: 1px;
  background: var(--jp-stats-row-divider);
  pointer-events: none;
}
/* The pill is narrower than its grid track, so centre it there — otherwise it sits at the
   track's left edge and the "#" heading above no longer lines up with the numbers. */
.cYF342vVRhGKriANRp6Q {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-start;
  width: var(--jp-stats-rank-width);
  height: 24px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 14px;
  font-weight: 800;
  color: var(--ash-grey, #b0b0b0);
  font-family: var(--font-family-secondary);
}
.N7il668majuTrsKXwZ6_ {
  font-size: 14px;
  font-weight: 800;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--ash-grey, #b0b0b0);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--font-family-secondary);
}
/* Left-aligned, matching its column header — the level wordmark and the amount
   share a left edge so the amounts read as a column. */
.culh0ZUhN_qb7vRuOprw {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  min-width: 0;
}
.tAbnvIj2usPS958pQriO {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  --jp-stats-label-height: 14px;
}
.OPsZgl5qRI6p8FRei6Fq {
  align-self: stretch;
  min-width: 0;
  font-weight: 800;
  color: var(--white-color, #fff);
  font-family: var(--font-family-secondary);
  line-height: 1;
  letter-spacing: 0%;
}
.GJQowHz00_VrF89GMTFR {
  margin-left: calc(3em / 16);
  font-size: calc(10em / 16);
  font-weight: 800;
  color: var(--white-color, #fff);
  font-family: var(--font-family-secondary);
  line-height: 100%;
  letter-spacing: 0%;
}
/* Sized for AutoTextfit's checks. Flex, so its div is as wide as the text and not as the column:
   a full-width div's scrollWidth never drops below the column and the fit runs to the minimum.
   The div keeps a 1em line box (16px / 29px), tighter than the glyphs' content area (~1.15em), so
   its scrollHeight is 1-4px taller than the box; the padding lifts the wrapper's clientHeight above
   that, and the matching negative margin keeps the layout height unchanged. overflow clips the
   pre-fit frame (text at max size) at the column edge. */
.NE6TEvyrzzzDhuh4Ia7Q,
.OPsZgl5qRI6p8FRei6Fq {
  display: flex;
  overflow: hidden;
  padding: 3px 0;
  margin: -3px 0;
}
/* AutoTextfit fits to the wrapper's width minus 8px. Widening the wrapper into the grid gap makes
   that target the real column width (the gap is 6px on narrow phones, so 2px short there); the
   number itself never enters the gap, and the wrapper's overflow clip ends where the gap ends. */
.OPsZgl5qRI6p8FRei6Fq {
  margin-right: calc(-1 * var(--jp-stats-grid-gap));
}
.NE6TEvyrzzzDhuh4Ia7Q > div,
.OPsZgl5qRI6p8FRei6Fq > div {
  line-height: 1;
}
/* Left-aligned, matching its column header — the time and the date below it share a left edge. */
.Nxw2UNoNFHlOFicY8qVr {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.25;
}
.k2O_al5WBiQ5UvNSGqKA {
  font-size: 13px;
  font-weight: 800;
  color: var(--ash-grey, #b0b0b0);
  opacity: 0.7;
  white-space: nowrap;
  font-family: var(--font-family-secondary);
}
.HRN14_DCeQhqZZ5Jw8DO {
  font-size: 13px;
  font-weight: 800;
  color: var(--ash-grey, #b0b0b0);
  white-space: nowrap;
  font-family: var(--font-family-secondary);
}
/* Pushed to the right edge of its track, flush with the row's right padding; the left-aligned
   GAME heading labels the track, not the button. */
.xHyJs6qmCVa3bEQmG8nR {
  position: relative;
  display: block;
  width: 40px;
  height: 50px;
  padding: 0;
  justify-self: right;
  border: 0;
  overflow: hidden;
  background: #222;
  cursor: pointer;
  border-radius: 5.14px;
}
.xHyJs6qmCVa3bEQmG8nR:disabled {
  cursor: wait;
}
.urFvD4CoYtXFTesdWi6e {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  display: block;
  border-radius: 5.14px;
}
/* Footer panel */
.mqs_wFZ0ckn0mVOvsxqK {
  --jp-stats-surface-dark: #101012;
  --jp-stats-close-bg: #101012;
  --jp-stats-control-radius: 8px;
  --jp-stats-control-border-width: 0.9px;
  --jp-stats-control-padding: 2px;
  --jp-stats-control-gap: 6px;
  --jp-stats-chip-height: 50px;
  --jp-stats-close-size: 44px;
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: var(--jp-stats-control-gap);
  padding: 10px 8px;
  background: #1c1c1e;
}
.mqs_wFZ0ckn0mVOvsxqK::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 40px;
  background: linear-gradient(180deg, rgba(29, 29, 31, 0) 19.01%, #1c1c1e 89.29%);
  pointer-events: none;
}
.V87EAEqKSgQY6VxY9lPE {
  display: flex;
  align-items: stretch;
  gap: var(--jp-stats-control-gap);
}
.AUV0hNF1y3PKhMGcYAEn {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  height: var(--jp-stats-chip-height);
  padding: var(--jp-stats-control-padding);
  border: var(--jp-stats-control-border-width) solid transparent;
  border-radius: var(--jp-stats-control-radius);
  background: var(--jp-stats-surface-dark);
  overflow: hidden;
  cursor: pointer;
  --jp-stats-label-height: 14px;
}
/*
 * Selected-chip fills follow the ARTWORK's colour, not the tier's rank: Premium Link's
 * Super / Middle wordmarks are green / blue, so they share major's and minor's fills — matching
 * by rank would put SUPER on grand's red against green artwork. Its Mini is magenta like
 * everyone else's.
 */
.AUV0hNF1y3PKhMGcYAEn[data-selected='true'][data-level='grand'] {
  background: #2d070e;
  border-color: #851a27;
}
.AUV0hNF1y3PKhMGcYAEn[data-selected='true'][data-level='major'],
.AUV0hNF1y3PKhMGcYAEn[data-selected='true'][data-level='super'] {
  background: #062b10;
  border-color: #0d5510;
}
.AUV0hNF1y3PKhMGcYAEn[data-selected='true'][data-level='minor'],
.AUV0hNF1y3PKhMGcYAEn[data-selected='true'][data-level='middle'] {
  background: #071847;
  border-color: #07437a;
}
.AUV0hNF1y3PKhMGcYAEn[data-selected='true'][data-level='mini'] {
  background: #320c44;
  border-color: #6b1888;
}
.eHn79D7_MCpbqapRPa3a {
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  justify-content: center;
  min-width: 0;
  max-width: 100%;
}
.ZRTnA8EFBt4A6ItGi6Mz {
  flex: 0 0 auto;
  font-size: 16px;
  font-weight: 800;
  color: var(--ghost-white-color, #f9f9f9);
  white-space: nowrap;
  line-height: 100%;
  letter-spacing: 0%;
  font-family: var(--font-family-secondary);
}
.AUV0hNF1y3PKhMGcYAEn:not([data-selected='true']) .eHn79D7_MCpbqapRPa3a,
.AUV0hNF1y3PKhMGcYAEn:not([data-selected='true']) .ZRTnA8EFBt4A6ItGi6Mz {
  opacity: 0.5;
}
.MhvvFb_Cw515BhBMGLH8 {
  display: flex;
  align-items: center;
  gap: var(--jp-stats-control-gap);
}
.xIa2IMYjizCwTirW9M3p {
  --jp-stats-sort-gap: 10px;
  --jp-stats-sort-height: 44px;
  /* outer container */
  --jp-stats-sort-item-height: 35px;
  /* the buttons and the sliding pill */
  /* Vertical breathing room, derived so the pill stays centred if either height changes. */
  --jp-stats-sort-inset: calc((var(--jp-stats-sort-height) - var(--jp-stats-sort-item-height)) / 2);
  height: var(--jp-stats-sort-height);
  position: relative;
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: var(--jp-stats-sort-gap);
  padding: 0 var(--jp-stats-sort-inset);
  background: var(--jp-stats-surface-dark);
  border-radius: var(--jp-stats-control-radius);
}
.xIa2IMYjizCwTirW9M3p::before {
  content: '';
  position: absolute;
  top: var(--jp-stats-sort-inset);
  left: var(--jp-stats-sort-inset);
  height: var(--jp-stats-sort-item-height);
  /*
   * One half of the space the buttons actually occupy: the container's width less both side
   * insets and the gap between the two. Percentages here resolve against the PADDING box, so the
   * insets have to be subtracted explicitly — they are not already excluded.
   */
  width: calc((100% - 2 * var(--jp-stats-sort-inset) - var(--jp-stats-sort-gap)) / 2);
  border-radius: 4px;
  background: #323334;
  box-shadow: 0 1px 0 0 #444444 inset;
  /* Slow ease-out: quick to start moving, settling gently rather than stopping abruptly. */
  transition: transform 0.45s cubic-bezier(0.33, 1, 0.68, 1);
  pointer-events: none;
}
/* TOP 10 selected — slide the pill across its own width plus the gap. */
.xIa2IMYjizCwTirW9M3p[data-selected='top_10']::before {
  transform: translateX(calc(100% + var(--jp-stats-sort-gap)));
}
/* Respect a reduced-motion preference: the pill still moves, just without the animation. */
@media (prefers-reduced-motion: reduce) {
  .xIa2IMYjizCwTirW9M3p::before {
    transition: none;
  }
}
.JdNimjIKlOVlvhHUNKxf {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  height: var(--jp-stats-sort-item-height);
  min-height: var(--jp-stats-sort-item-height);
  padding: var(--jp-stats-control-padding);
  border: var(--jp-stats-control-border-width) solid transparent;
  border-radius: 4px;
  /* Transparent: the container's sliding pill paints the selected fill behind it. */
  background: transparent;
  position: relative;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--ash-grey, #b0b0b0);
  text-transform: uppercase;
  cursor: pointer;
  font-family: var(--font-family-primary);
  opacity: 0.5;
}
.JdNimjIKlOVlvhHUNKxf[data-selected='true'] {
  color: var(--white-color, #fff);
  opacity: 1;
}
.oSYpRHkUZA4dpXYTVx3P {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: var(--jp-stats-close-size);
  height: var(--jp-stats-close-size);
  padding: var(--jp-stats-control-padding);
  border: var(--jp-stats-control-border-width) solid transparent;
  border-radius: var(--jp-stats-control-radius);
  background: var(--jp-stats-close-bg);
  cursor: pointer;
}
.HYaGE5T5AGuUa_Nj6QLc {
  display: block;
  width: 14px;
  height: 14px;
  object-fit: contain;
}
/* Narrow phones */
@media (max-width: 380px) {
  .s9KFsU6iWhBmUAGF8u5S,
  .oFocP4cgUkcqw8g1fHhp {
    --jp-stats-grid-gap: 6px;
    --jp-stats-grid-padding: 8px;
    --jp-stats-rank-col: 28px;
    grid-template-columns: var(--jp-stats-rank-col) minmax(44px, 0.8fr) minmax(84px, 1.4fr) minmax(58px, 1fr) var(--jp-stats-game-col);
  }
  .AUV0hNF1y3PKhMGcYAEn {
    gap: 3px;
    --jp-stats-label-height: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/JackpotStatistics/JackpotStatistics.module.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,kDAAkD;EAClD,4BAA4B;EAC5B,4IAA4I;EAC5I,6EAA6E;EAC7E,8BAA8B;EAC9B,4BAA4B;EAC5B,2CAA2C;EAC3C,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,uCAAuC;EACvC,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;EAC1C;4FAC0F;EAC1F,sDAAsD;EACtD,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,sGAAsG;EACtG,gEAAgE;EAChE,iHAAiH;EACjH,uCAAuC;EACvC,uEAA+D;AACjE;AACA;;;;;;;;EAQE;AACF;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,0CAA0C;IAC1C,2CAA2C;IAC3C,8CAA8C;IAC9C,+CAA+C;EACjD;AACF;AACA;;;;EAIE;AACF;EACE;IACE,qBAAqB;IACrB,uBAAuB;EACzB;EACA;;8EAE4E;EAC5E;IACE,WAAW;IACX,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;IAChB,uCAAuC;IACvC,sGAAsG;IACtG,gEAAgE;IAChE,iHAAiH;IACjH,uCAAuC;EACzC;AACF;AACA;EACE;IACE,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE,aAAa;EACb,cAAc;EACd;kDACgD;EAChD,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE;AACF;EACE;IACE,aAAa;EACf;AACF;AACA,gGAAgG;AAChG;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,WAAW;EACX,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB;AACA,+FAA+F;AAC/F;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,yCAAyC;EACzC,iBAAiB;AACnB;AACA;;sDAEsD;AACtD;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;EACzC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;AACA,0DAA0D;AAC1D;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,8DAA8D;EAC9D,mBAAmB;AACrB;AACA;8DAC8D;AAC9D;EACE,wBAAwB;AAC1B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,2FAA2F;EAC3F,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,sFAAsF;EACtF,2BAA2B;EAC3B,aAAa;EACb,kIAAkI;EAClI,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qCAAqC;AACvC;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;;EAKE;AACF;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;wEACwE;AACxE;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;AACA,sFAAsF;AACtF;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;;;;;EAKE;AACF;EACE,WAAW;EACX,kBAAkB;EAClB;;;;;IAKE;EACF,4GAA4G;EAC5G,wFAAwF;EACxF,+FAA+F;EAC/F,SAAS;EACT,WAAW;EACX,uCAAuC;EACvC,oBAAoB;AACtB;AACA;qFACqF;AACrF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;uDACuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;EACzC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;;;;yDAKyD;AACzD;;EAEE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;;iGAEiG;AACjG;EACE,iDAAiD;AACnD;AACA;;EAEE,cAAc;AAChB;AACA,iGAAiG;AACjG;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;mDACmD;AACnD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB;AACA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,+EAA+E;EAC/E,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mCAAmC;EACnC,wCAAwC;EACxC,8DAA8D;EAC9D,6CAA6C;EAC7C,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;AACA;;;;;EAKE;AACF;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;;EAEE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;EACpB,iCAAiC;EACjC,qCAAqC;EACrC,yFAAyF;EACzF,iGAAiG;EACjG,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;EACrC,wCAAwC;EACxC,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,wCAAwC;EACxC;;;;IAIE;EACF,mFAAmF;EACnF,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,yFAAyF;EACzF,0DAA0D;EAC1D,oBAAoB;AACtB;AACA,wEAAwE;AACxE;EACE,4DAA4D;AAC9D;AACA,2FAA2F;AAC3F;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,4CAA4C;EAC5C,wCAAwC;EACxC,8DAA8D;EAC9D,kBAAkB;EAClB,kFAAkF;EAClF,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;EACf,uCAAuC;EACvC,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,UAAU;AACZ;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;EAClC,wCAAwC;EACxC,8DAA8D;EAC9D,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,kBAAkB;AAClB;EACE;;IAEE,wBAAwB;IACxB,4BAA4B;IAC5B,yBAAyB;IACzB,kIAAkI;EACpI;EACA;IACE,QAAQ;IACR,6BAA6B;EAC/B;AACF","sourcesContent":["/* Jackpot statistics drawer. */\n.overlay {\n  --jp-stats-gold: #FFC61B;\n  --jp-stats-row-divider: #2e2e2e;\n  --jp-stats-radius: 12px;\n  --jp-stats-border-width: 2px;\n  --jp-stats-border-color: rgba(255, 255, 255, 0.15);\n  --jp-stats-head-height: 30px;\n  --jp-stats-gradient: linear-gradient(180deg, #323334 0, #323334 var(--jp-stats-radius), #101012 var(--jp-stats-head-height), #1c1c1e 83.29%);\n  --jp-stats-header-gradient: linear-gradient(180deg, #323334 0%, #101012 100%);\n  --jp-stats-shadow-offset: 20px;\n  --jp-stats-shadow-blur: 40px;\n  --jp-stats-shadow-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  background: rgba(0, 0, 0, 0.65);\n  font-family: var(--font-family-primary);\n  overscroll-behavior: contain;\n  align-items: stretch;\n  justify-content: flex-end;\n}\n.drawer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n  background: var(--jp-stats-gradient);\n  background-origin: border-box;\n  color: var(--white-color, #fff);\n  border-style: solid;\n  border-color: var(--jp-stats-border-color);\n  /* The notch inset is ADDED to the width, not carved out of it: with border-box sizing a bare\n     375px would lose the safe-area padding from its content box and clip the GAME column. */\n  width: min(calc(375px + var(--safe-right, 0px)), 100%);\n  height: 100vh;\n  height: 100dvh;\n  max-height: 100vh;\n  max-height: 100dvh;\n  padding-right: var(--safe-right, 0px);\n  border-width: var(--jp-stats-border-width) 0 var(--jp-stats-border-width) var(--jp-stats-border-width);\n  border-radius: var(--jp-stats-radius) 0 0 var(--jp-stats-radius);\n  box-shadow: calc(-1 * var(--jp-stats-shadow-offset)) 0 var(--jp-stats-shadow-blur) 0 var(--jp-stats-shadow-color);\n  --jp-stats-enter-from: translateX(24px);\n  animation: jpStatsEnter 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n/*\n * DESKTOP - the whole drawer is drawn 1.25x.\n *\n * Done with one `zoom` rather than by multiplying the ~100 px literals in this file: zoom scales\n * LAYOUT, not just paint, so every token (widths, gaps, radii, borders, font sizes, the row grid)\n * grows by exactly the same factor, text is rasterised at the larger size instead of being\n * stretched, and hit areas follow. The numbers below stay the Figma mobile numbers, which is what\n * makes them checkable against the design.\n */\n@media (min-width: 1024px) {\n  .overlay[data-device='desktop'] .drawer {\n    --jp-stats-zoom: 1.25;\n    zoom: var(--jp-stats-zoom);\n    height: calc(100vh / var(--jp-stats-zoom));\n    height: calc(100dvh / var(--jp-stats-zoom));\n    max-height: calc(100vh / var(--jp-stats-zoom));\n    max-height: calc(100dvh / var(--jp-stats-zoom));\n  }\n}\n/*\n * PHONE PORTRAIT — and only phone portrait — turns the side drawer into a bottom sheet. Every\n * other form factor keeps the right-side drawer above, iPads and tablets included.\n *\n */\n@media (orientation: portrait) and (max-width: 600px) {\n  .overlay {\n    align-items: flex-end;\n    justify-content: center;\n  }\n  /* Mirrored to the bottom edge: radius on the top two corners, no border on the bottom,\n     shadow cast upward over the lobby. A FIXED height, not content-driven: switching to a level\n     with fewer wins must not shrink the sheet and shift it down the screen. */\n  .drawer {\n    width: 100%;\n    height: calc(100vh * 0.86);\n    height: calc(100dvh * 0.86);\n    max-height: calc(100vh * 0.86);\n    max-height: calc(100dvh * 0.86);\n    padding-right: 0;\n    padding-bottom: var(--safe-bottom, 0px);\n    border-width: var(--jp-stats-border-width) var(--jp-stats-border-width) 0 var(--jp-stats-border-width);\n    border-radius: var(--jp-stats-radius) var(--jp-stats-radius) 0 0;\n    box-shadow: 0 calc(-1 * var(--jp-stats-shadow-offset)) var(--jp-stats-shadow-blur) 0 var(--jp-stats-shadow-color);\n    --jp-stats-enter-from: translateY(24px);\n  }\n}\n@keyframes jpStatsEnter {\n  0% {\n    opacity: 0;\n    transform: var(--jp-stats-enter-from);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n}\n/* Header panel */\n.headerPanel {\n  display: flex;\n  flex: 0 0 auto;\n  /* The drawer fill’s light top, now attached to the panel it was drawn for so it scrolls away\n     with it instead of staying behind the list. */\n  background: var(--jp-stats-header-gradient);\n  gap: 12px;\n  padding: 8px 8px;\n}\n/*\n * PHONE LANDSCAPE — and only phone landscape — drops the header\n */\n@media (orientation: landscape) and (max-height: 600px) and (pointer: coarse) {\n  .headerPanel {\n    display: none;\n  }\n}\n/* Caption only — no win under the current filter. Centred so the band still reads as a title. */\n.headerPanelEmpty {\n  justify-content: center;\n  padding: 10px 8px;\n}\n.headerThumb {\n  position: relative;\n  display: block;\n  flex: 0 0 auto;\n  width: 89px;\n  height: 102px;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n  background: #222;\n  cursor: pointer;\n  border-radius: 6.85px;\n}\n.headerThumb:disabled {\n  cursor: wait;\n}\n.headerThumbImg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: top;\n  display: block;\n  border-radius: 6.85px;\n}\n/* Three stacked lines to the right of the thumbnail, left-aligned: caption / level / amount. */\n.headerInfo {\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 2px;\n  margin-top: 1px;\n}\n.headerCaption {\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: var(--jp-stats-gold);\n  text-transform: uppercase;\n  font-family: var(--font-family-secondary);\n  line-height: 100%;\n}\n/* The amount is white; only the level wordmark image carries colour. Stretched to the column so\n   AutoTextfit scales the number to it (its maxFontSize sets the size); the currency is in em\n   so it scales along. Same for .payoutAmount below. */\n.headerAmount {\n  align-self: stretch;\n  min-width: 0;\n  font-weight: 800;\n  color: var(--white-color, #fff);\n  font-family: var(--font-family-secondary);\n  line-height: 1;\n  letter-spacing: 0%;\n}\n.headerInfo:not([data-premium-link='true']) .headerCaption {\n  position: relative;\n  left: 1px;\n}\n.headerCurrency {\n  margin-left: calc(4em / 29);\n  font-size: calc(14em / 29);\n  font-weight: 800;\n  color: var(--white-color, #fff);\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n/* Level label (shared by header, rows and footer chips) */\n.levelLabelImg {\n  display: block;\n  width: auto;\n  max-width: 100%;\n  height: var(--jp-stats-label-height, 14px);\n  object-fit: contain;\n}\n.levelLabelText {\n  font-size: calc(var(--jp-stats-label-height, 14px) * 0.85);\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  line-height: 1;\n  color: var(--jp-level-text, var(--ghost-white-color, #f9f9f9));\n  white-space: nowrap;\n}\n/* Premium Link's Super / Middle wordmarks are green / blue, so they share major's and minor's\n   colours; its Mini is the same magenta as everyone else's. */\n.levelLabelText[data-level='grand'] {\n  --jp-level-text: #ff5b6e;\n}\n.levelLabelText[data-level='major'],\n.levelLabelText[data-level='super'] {\n  --jp-level-text: #3ddc61;\n}\n.levelLabelText[data-level='minor'],\n.levelLabelText[data-level='middle'] {\n  --jp-level-text: #5b9bff;\n}\n.levelLabelText[data-level='mini'] {\n  --jp-level-text: #cf7bee;\n}\n.vipBadge {\n  display: block;\n  flex: 0 0 auto;\n  width: auto;\n  height: var(--jp-stats-vip-height, 13.17px);\n  margin-right: 4px;\n  object-fit: contain;\n}\n.headerLevel {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  max-width: 100%;\n  --jp-stats-label-height: 24px;\n  --jp-stats-vip-height: 24px;\n}\n/* Content panel */\n.contentPanel {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n  flex-direction: column;\n}\n.tableHead,\n.row {\n  /* Named so the row separator can line up with both ends of the grid — see `.row::after`. */\n  --jp-stats-grid-gap: 8px;\n  --jp-stats-grid-padding: 8px;\n  --jp-stats-game-col: 44px;\n  --jp-stats-rank-col: 34px;\n  /* Width of the rank pill itself, which is centred in the track above — see `.rank`. */\n  --jp-stats-rank-width: 24px;\n  display: grid;\n  grid-template-columns: var(--jp-stats-rank-col) minmax(52px, 0.8fr) minmax(96px, 1.4fr) minmax(64px, 1fr) var(--jp-stats-game-col);\n  align-items: center;\n  gap: var(--jp-stats-grid-gap);\n  padding: 0 var(--jp-stats-grid-padding);\n}\n.tableHead {\n  flex: 0 0 auto;\n  height: var(--jp-stats-head-height);\n  background: #252528;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  transition: box-shadow 0.15s ease-out;\n}\n.tableHead[data-elevated='true'] {\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.6), 0 14px 32px 0 rgba(0, 0, 0, 0.75);\n}\n.headCell {\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  color: var(--ash-grey, #b0b0b0);\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: var(--font-family-secondary);\n}\n.headCellCenter {\n  display: block;\n  text-align: center;\n  position: relative;\n  left: -4px;\n}\n/*\n * One scroller for the header panel, the sticky column headings and the rows. The scrollbar is\n * hidden rather than styled: the Figma frames show none, and a classic scrollbar would eat ~10px\n * of layout width mid-list. Scrolling itself is untouched — wheel, trackpad, touch and keyboard\n * all still work; on touch platforms scrollbars already overlay at zero width.\n */\n.scroller {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: none;\n  touch-action: pan-y;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n.scroller::-webkit-scrollbar {\n  display: none;\n}\n/* While there are no rows the list is a flex column, so the placeholder below the sticky\n   headings can take all the remaining height and centre itself in it. */\n.scroller[data-empty='true'] {\n  display: flex;\n  flex-direction: column;\n}\n.emptyState {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 24px;\n  text-align: center;\n}\n.emptyIcon {\n  display: block;\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n}\n.emptyText {\n  margin: 0;\n  max-width: 280px;\n  font-family: var(--font-family-secondary);\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.3;\n  color: var(--white-color, #fff);\n}\n/* Focused programmatically on open (keyboard scroll target) — never a visible ring. */\n.scroller:focus {\n  outline: none;\n}\n.row {\n  position: relative;\n  height: 56px;\n}\n/*\n * Separator drawn as a pseudo-element rather than `border-bottom`, because it must stop where the\n * GAME column begins instead of running the full width under the thumbnail. The right offset is\n * derived from the grid itself — game track + the gap before it + the row's right padding — so it\n * follows automatically if any of those change.\n */\n.row::after {\n  content: '';\n  position: absolute;\n  /*\n   * Starts at the left edge of the rank PILL, not of its grid track and not of the drawer:\n   * offsets on an absolutely positioned child resolve against the PADDING box, so the row's own\n   * padding is added back, plus the slack the pill is centred by inside its wider track. Derived\n   * rather than hard-coded, so the narrow-phone track override below stays aligned.\n   */\n  left: calc(var(--jp-stats-grid-padding) + (var(--jp-stats-rank-col) - var(--jp-stats-rank-width)) / 2 - 4px);\n  /* Ends exactly where the TIME & DATE track ends — i.e. one gap before the GAME track. */\n  right: calc(var(--jp-stats-game-col) + var(--jp-stats-grid-gap) + var(--jp-stats-grid-padding));\n  bottom: 0;\n  height: 1px;\n  background: var(--jp-stats-row-divider);\n  pointer-events: none;\n}\n/* The pill is narrower than its grid track, so centre it there — otherwise it sits at the\n   track's left edge and the \"#\" heading above no longer lines up with the numbers. */\n.rank {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  justify-self: flex-start;\n  width: var(--jp-stats-rank-width);\n  height: 24px;\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--ash-grey, #b0b0b0);\n  font-family: var(--font-family-secondary);\n}\n.player {\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--ash-grey, #b0b0b0);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: var(--font-family-secondary);\n}\n/* Left-aligned, matching its column header — the level wordmark and the amount\n   share a left edge so the amounts read as a column. */\n.payout {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 2px;\n  min-width: 0;\n}\n.payoutLevel {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  --jp-stats-label-height: 14px;\n}\n.payoutAmount {\n  align-self: stretch;\n  min-width: 0;\n  font-weight: 800;\n  color: var(--white-color, #fff);\n  font-family: var(--font-family-secondary);\n  line-height: 1;\n  letter-spacing: 0%;\n}\n.payoutCurrency {\n  margin-left: calc(3em / 16);\n  font-size: calc(10em / 16);\n  font-weight: 800;\n  color: var(--white-color, #fff);\n  font-family: var(--font-family-secondary);\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n/* Sized for AutoTextfit's checks. Flex, so its div is as wide as the text and not as the column:\n   a full-width div's scrollWidth never drops below the column and the fit runs to the minimum.\n   The div keeps a 1em line box (16px / 29px), tighter than the glyphs' content area (~1.15em), so\n   its scrollHeight is 1-4px taller than the box; the padding lifts the wrapper's clientHeight above\n   that, and the matching negative margin keeps the layout height unchanged. overflow clips the\n   pre-fit frame (text at max size) at the column edge. */\n.headerAmount,\n.payoutAmount {\n  display: flex;\n  overflow: hidden;\n  padding: 3px 0;\n  margin: -3px 0;\n}\n/* AutoTextfit fits to the wrapper's width minus 8px. Widening the wrapper into the grid gap makes\n   that target the real column width (the gap is 6px on narrow phones, so 2px short there); the\n   number itself never enters the gap, and the wrapper's overflow clip ends where the gap ends. */\n.payoutAmount {\n  margin-right: calc(-1 * var(--jp-stats-grid-gap));\n}\n.headerAmount > div,\n.payoutAmount > div {\n  line-height: 1;\n}\n/* Left-aligned, matching its column header — the time and the date below it share a left edge. */\n.timeAndDate {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.25;\n}\n.time {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--ash-grey, #b0b0b0);\n  opacity: 0.7;\n  white-space: nowrap;\n  font-family: var(--font-family-secondary);\n}\n.date {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--ash-grey, #b0b0b0);\n  white-space: nowrap;\n  font-family: var(--font-family-secondary);\n}\n/* Pushed to the right edge of its track, flush with the row's right padding; the left-aligned\n   GAME heading labels the track, not the button. */\n.gameButton {\n  position: relative;\n  display: block;\n  width: 40px;\n  height: 50px;\n  padding: 0;\n  justify-self: right;\n  border: 0;\n  overflow: hidden;\n  background: #222;\n  cursor: pointer;\n  border-radius: 5.14px;\n}\n.gameButton:disabled {\n  cursor: wait;\n}\n.gameThumb {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: top;\n  display: block;\n  border-radius: 5.14px;\n}\n/* Footer panel */\n.footerPanel {\n  --jp-stats-surface-dark: #101012;\n  --jp-stats-close-bg: #101012;\n  --jp-stats-control-radius: 8px;\n  --jp-stats-control-border-width: 0.9px;\n  --jp-stats-control-padding: 2px;\n  --jp-stats-control-gap: 6px;\n  --jp-stats-chip-height: 50px;\n  --jp-stats-close-size: 44px;\n  position: relative;\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  gap: var(--jp-stats-control-gap);\n  padding: 10px 8px;\n  background: #1c1c1e;\n}\n.footerPanel::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 100%;\n  height: 40px;\n  background: linear-gradient(180deg, rgba(29, 29, 31, 0) 19.01%, #1c1c1e 89.29%);\n  pointer-events: none;\n}\n.levelChips {\n  display: flex;\n  align-items: stretch;\n  gap: var(--jp-stats-control-gap);\n}\n.levelChip {\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  height: var(--jp-stats-chip-height);\n  padding: var(--jp-stats-control-padding);\n  border: var(--jp-stats-control-border-width) solid transparent;\n  border-radius: var(--jp-stats-control-radius);\n  background: var(--jp-stats-surface-dark);\n  overflow: hidden;\n  cursor: pointer;\n  --jp-stats-label-height: 14px;\n}\n/*\n * Selected-chip fills follow the ARTWORK's colour, not the tier's rank: Premium Link's\n * Super / Middle wordmarks are green / blue, so they share major's and minor's fills — matching\n * by rank would put SUPER on grand's red against green artwork. Its Mini is magenta like\n * everyone else's.\n */\n.levelChip[data-selected='true'][data-level='grand'] {\n  background: #2d070e;\n  border-color: #851a27;\n}\n.levelChip[data-selected='true'][data-level='major'],\n.levelChip[data-selected='true'][data-level='super'] {\n  background: #062b10;\n  border-color: #0d5510;\n}\n.levelChip[data-selected='true'][data-level='minor'],\n.levelChip[data-selected='true'][data-level='middle'] {\n  background: #071847;\n  border-color: #07437a;\n}\n.levelChip[data-selected='true'][data-level='mini'] {\n  background: #320c44;\n  border-color: #6b1888;\n}\n.levelChipLabel {\n  display: flex;\n  flex: 0 1 auto;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  max-width: 100%;\n}\n.levelChipCount {\n  flex: 0 0 auto;\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--ghost-white-color, #f9f9f9);\n  white-space: nowrap;\n  line-height: 100%;\n  letter-spacing: 0%;\n  font-family: var(--font-family-secondary);\n}\n.levelChip:not([data-selected='true']) .levelChipLabel,\n.levelChip:not([data-selected='true']) .levelChipCount {\n  opacity: 0.5;\n}\n.sortRow {\n  display: flex;\n  align-items: center;\n  gap: var(--jp-stats-control-gap);\n}\n.sortGroup {\n  --jp-stats-sort-gap: 10px;\n  --jp-stats-sort-height: 44px;\n  /* outer container */\n  --jp-stats-sort-item-height: 35px;\n  /* the buttons and the sliding pill */\n  /* Vertical breathing room, derived so the pill stays centred if either height changes. */\n  --jp-stats-sort-inset: calc((var(--jp-stats-sort-height) - var(--jp-stats-sort-item-height)) / 2);\n  height: var(--jp-stats-sort-height);\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n  gap: var(--jp-stats-sort-gap);\n  padding: 0 var(--jp-stats-sort-inset);\n  background: var(--jp-stats-surface-dark);\n  border-radius: var(--jp-stats-control-radius);\n}\n.sortGroup::before {\n  content: '';\n  position: absolute;\n  top: var(--jp-stats-sort-inset);\n  left: var(--jp-stats-sort-inset);\n  height: var(--jp-stats-sort-item-height);\n  /*\n   * One half of the space the buttons actually occupy: the container's width less both side\n   * insets and the gap between the two. Percentages here resolve against the PADDING box, so the\n   * insets have to be subtracted explicitly — they are not already excluded.\n   */\n  width: calc((100% - 2 * var(--jp-stats-sort-inset) - var(--jp-stats-sort-gap)) / 2);\n  border-radius: 4px;\n  background: #323334;\n  box-shadow: 0 1px 0 0 #444444 inset;\n  /* Slow ease-out: quick to start moving, settling gently rather than stopping abruptly. */\n  transition: transform 0.45s cubic-bezier(0.33, 1, 0.68, 1);\n  pointer-events: none;\n}\n/* TOP 10 selected — slide the pill across its own width plus the gap. */\n.sortGroup[data-selected='top_10']::before {\n  transform: translateX(calc(100% + var(--jp-stats-sort-gap)));\n}\n/* Respect a reduced-motion preference: the pill still moves, just without the animation. */\n@media (prefers-reduced-motion: reduce) {\n  .sortGroup::before {\n    transition: none;\n  }\n}\n.sortButton {\n  display: flex;\n  flex: 1 1 0;\n  align-items: center;\n  justify-content: center;\n  height: var(--jp-stats-sort-item-height);\n  min-height: var(--jp-stats-sort-item-height);\n  padding: var(--jp-stats-control-padding);\n  border: var(--jp-stats-control-border-width) solid transparent;\n  border-radius: 4px;\n  /* Transparent: the container's sliding pill paints the selected fill behind it. */\n  background: transparent;\n  position: relative;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: var(--ash-grey, #b0b0b0);\n  text-transform: uppercase;\n  cursor: pointer;\n  font-family: var(--font-family-primary);\n  opacity: 0.5;\n}\n.sortButton[data-selected='true'] {\n  color: var(--white-color, #fff);\n  opacity: 1;\n}\n.closeButton {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  width: var(--jp-stats-close-size);\n  height: var(--jp-stats-close-size);\n  padding: var(--jp-stats-control-padding);\n  border: var(--jp-stats-control-border-width) solid transparent;\n  border-radius: var(--jp-stats-control-radius);\n  background: var(--jp-stats-close-bg);\n  cursor: pointer;\n}\n.closeIcon {\n  display: block;\n  width: 14px;\n  height: 14px;\n  object-fit: contain;\n}\n/* Narrow phones */\n@media (max-width: 380px) {\n  .tableHead,\n  .row {\n    --jp-stats-grid-gap: 6px;\n    --jp-stats-grid-padding: 8px;\n    --jp-stats-rank-col: 28px;\n    grid-template-columns: var(--jp-stats-rank-col) minmax(44px, 0.8fr) minmax(84px, 1.4fr) minmax(58px, 1fr) var(--jp-stats-game-col);\n  }\n  .levelChip {\n    gap: 3px;\n    --jp-stats-label-height: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `FoAxJKgkOhyTlHyJOvOJ`,
	"drawer": `Q0Qd6fpVaABhND1xnxOg`,
	"jpStatsEnter": `k2EIwtF9CVBnhlj9zKTB`,
	"headerPanel": `gS07Do2zmX4KudQvS3DR`,
	"headerPanelEmpty": `qONfW82yXw1jyr7UMeXv`,
	"headerThumb": `Dax7maqz0rgckGT6LGJQ`,
	"headerThumbImg": `ZoSN__XbMQz4vysP6_A8`,
	"headerInfo": `h2jGJfsoJzyNMc46SD31`,
	"headerCaption": `d1dam9Pcd5Upc1gvrLFx`,
	"headerAmount": `NE6TEvyrzzzDhuh4Ia7Q`,
	"headerCurrency": `g23TnvbRQ4colqleaP0w`,
	"levelLabelImg": `ofEWnpTpzDRwbq8XUyEo`,
	"levelLabelText": `LgA6RFMrGS6jHjqULHf9`,
	"vipBadge": `D_SOBmY1InznkrXKANTo`,
	"headerLevel": `YsTRDYu6JUjqkD9pLxYY`,
	"contentPanel": `GYmPaGqowkvFuatXOxWN`,
	"tableHead": `s9KFsU6iWhBmUAGF8u5S`,
	"row": `oFocP4cgUkcqw8g1fHhp`,
	"headCell": `DakiyXCSai9hGjKibeaq`,
	"headCellCenter": `k4QRwIt6ArDhL48Dy6YP`,
	"scroller": `zLVTnBcxFojqnkpRgfxL`,
	"emptyState": `c64mltkptQUvUylrdtgj`,
	"emptyIcon": `xzvNql9GPRSzgL8BnBgj`,
	"emptyText": `B0yeNC1kM3iZAEEQKEAb`,
	"rank": `cYF342vVRhGKriANRp6Q`,
	"player": `N7il668majuTrsKXwZ6_`,
	"payout": `culh0ZUhN_qb7vRuOprw`,
	"payoutLevel": `tAbnvIj2usPS958pQriO`,
	"payoutAmount": `OPsZgl5qRI6p8FRei6Fq`,
	"payoutCurrency": `GJQowHz00_VrF89GMTFR`,
	"timeAndDate": `Nxw2UNoNFHlOFicY8qVr`,
	"time": `k2O_al5WBiQ5UvNSGqKA`,
	"date": `HRN14_DCeQhqZZ5Jw8DO`,
	"gameButton": `xHyJs6qmCVa3bEQmG8nR`,
	"gameThumb": `urFvD4CoYtXFTesdWi6e`,
	"footerPanel": `mqs_wFZ0ckn0mVOvsxqK`,
	"levelChips": `V87EAEqKSgQY6VxY9lPE`,
	"levelChip": `AUV0hNF1y3PKhMGcYAEn`,
	"levelChipLabel": `eHn79D7_MCpbqapRPa3a`,
	"levelChipCount": `ZRTnA8EFBt4A6ItGi6Mz`,
	"sortRow": `MhvvFb_Cw515BhBMGLH8`,
	"sortGroup": `xIa2IMYjizCwTirW9M3p`,
	"sortButton": `JdNimjIKlOVlvhHUNKxf`,
	"closeButton": `oSYpRHkUZA4dpXYTVx3P`,
	"closeIcon": `HYaGE5T5AGuUa_Nj6QLc`
};
export default ___CSS_LOADER_EXPORT___;
